import PropTypes from 'prop-types'
import { CoverImage } from '@redriverpress/system'

import { CONTENT_TYPES } from 'Common/constants/contentTypes'

import CoverImageFallback from './CardCoverImageFallback'

const STYLES = {
  small: {
    imageSize: '2.25rem',
    imageMinWidth: '2.25rem',
    iconFontSize: 1,
  },
  large: {
    imageSize: '6rem',
    imageMinWidth: '6rem',
    iconFontSize: 5,
  },
}

export default function CardCoverImage({
  alt,
  contentType,
  height,
  iconFontSize,
  large,
  size,
  src,
  width,
  borderRadius,
  ...props
}) {
  const styles = large ? STYLES.large : STYLES.small

  if (src) {
    return (
      <CoverImage
        src={src}
        size={width && height ? null : size || styles.imageSize}
        width={width}
        height={height}
        minWidth={styles.imageMinWidth}
        alt={alt}
        borderRadius={borderRadius}
        {...props}
      />
    )
  }

  return (
    <CoverImageFallback
      contentType={contentType}
      size={size || styles.imageSize}
      minWidth={styles.imageMinWidth}
      iconFontSize={iconFontSize || styles.iconFontSize}
      alt={alt}
      borderRadius={borderRadius}
      {...props}
    />
  )
}

CardCoverImage.defaultProps = {
  large: false,
  src: null,
  alt: null,
  size: null,
  iconFontSize: null,
  width: null,
  height: null,
  borderRadius: 'circular',
}

CardCoverImage.propTypes = {
  large: PropTypes.bool,
  src: PropTypes.string,
  alt: PropTypes.string,
  size: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.array,
  ]),
  width: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.array,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.array,
  ]),
  iconFontSize: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.array,
  ]),
  borderRadius: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.array,
  ]),
  contentType: PropTypes.oneOf([
    CONTENT_TYPES.flashcardCategory,
    CONTENT_TYPES.flashcardSet,
    CONTENT_TYPES.lesson,
    CONTENT_TYPES.course,
    CONTENT_TYPES.video,
  ]).isRequired,
}
